// @ts-nocheck
import * as React from 'react';
// SmLogo — SooMuch.AI logo mark.

export default function SmLogo() {
  return <img src="/admissions-assured/soomuch-logo.svg" alt="SooMuch.AI" />;
}
